import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { Helmet } from "react-helmet";

// @ts-ignore -- CSS side-effect imports are handled by the bundler.
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ensureMsalInitialized, msalInstance } from "./services/auth.service";
async function bootstrapApp() {
  await ensureMsalInitialized();
  await msalInstance.handleRedirectPromise();

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <React.StrictMode>
        <Helmet>
          <meta name="viewport" content="initial-scale=1, width=device-width" />
        </Helmet>
        <MsalProvider instance={msalInstance}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MsalProvider>
    </React.StrictMode>
  );
}

bootstrapApp().catch((error) => {
  console.error("MSAL bootstrap failed:", error);
});

reportWebVitals();
